import React from "react";
import no_data from '../../assets/svgs/no_data.svg'
import { Box, Text, Image } from "@chakra-ui/react";

type Props = { message: string }

export default function EmptyState({ message }: Props){
  return (
    <Box>
      <Box>
        <Image 
          src={no_data}
          w='300px'
          mx='auto'
        />
      </Box>

      <Text 
        mt={5}
        textColor='#313338'
        fontSize='xl'
        fontWeight='semibold'
        textAlign='center'
      >
        {message}
      </Text>
    </Box>
  )
}